import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useProductDetails } from "./useProductDetails";
import {
  setPrimaryCharacteristic,
  type SetPrimaryCharacteristicPayload,
} from "../services/regulatoryCharacteristicsService";

export const useProductRegulatoryFeatures = (productId: string) => {
  const {
    data: productDetails,
    isLoading,
    isError,
  } = useProductDetails(productId);

  return {
    data: productDetails?.regulatoryCharacteristics ?? [],
    isLoading,
    isError,
  };
};

/**
 * Hook to set a characteristic as primary for a product
 */
export const useSetPrimaryCharacteristic = (productId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setPrimaryCharacteristic,
    onSuccess: () => {
      // Invalidate and refetch product details to get updated isPrimaryCharacteristic flags
      queryClient.invalidateQueries({
        queryKey: ["productDetails", productId],
      });
    },
  });
};
